import React, { useState } from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import TextHeader from '../../components/TextHeader'
import SVG from 'react-inlinesvg'
import HistoryBackground from '../../assets/svg/mailgun-logo-background.svg'
import Arrow from '../../assets/svg/down.svg'

const StyledSlider = styled.div`
	background-color: #fdf8f8;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	position: relative;
	overflow: hidden;
	header {
		padding: 0 18%;
	}

	${({ theme }) => theme.media.desktop} {
		header {
			padding: 0px;
		}
	}
	.slick-track {
		display: flex;
	}
	.slick-arrow {
		width: 48px;
		height: 48px;
		box-shadow: 0 3px 3px -1px rgba(10, 22, 70, 0.1),
			0 0 1px 0 rgba(10, 22, 70, 0.06);
		background-color: ${({ theme }) => theme.colors.white};
		border-radius: 50%;
		display: flex !important;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		position: absolute;
		top: 78px;
		&.slick-prev {
			left: 15px;
			z-index: 2000;
			.isvg {
				transform: rotate(90deg);
			}
			${({ theme }) => theme.media.desktop} {
				left: 60px;
			}
		}
		&.slick-next {
			right: 15px;
			.isvg {
				transform: rotate(-90deg);
			}

			${({ theme }) => theme.media.desktop} {
				right: 60px;
			}
		}
	}
	.slick-dots {
		display: flex !important;
		width: 100%;
		margin: 80px auto 80px auto;
		justify-content: start;
		flex-wrap: nowrap;
		text-align: center;
		width: 200%;
		transform: translatex(-${({ current, total }) => current * total * 9}px);
		transition: 250ms;
		padding-left: 40%;
		${({ theme }) => theme.media.desktop} {
			padding: 0;
			justify-content: space-around;
			width: 40%;
			margin: 180px auto 80px auto;
			flex-wrap: nowrap;
			transform: none;
		}
		li {
			width: 33.333%;
			${({ theme }) => theme.media.desktop} {
				width: auto;
			}
			a {
				cursor: pointer;
				transition: 250ms;
				font-size: 1.25em;
				color: rgba(10, 31, 68, 0.24);
			}
			&.slick-active {
				a {
					color: #000;
				}
			}
		}
	}
`
const StyledBackground = styled(SVG)`
	position: absolute;
	top: 0;
`

const StyledSliderWrapper = styled.div`
	width: 100%;
	z-index: 2000;
	padding-top: 64px;
	${({ theme }) => theme.media.desktop} {
		padding-top: 312px;
	}
	.slick-slider {
		position: relative;
	}
`

const StyledYear = styled.a``

const SlickArrow = ({ className, style, onClick }) => (
	<div className={className} style={{ ...style }} onClick={onClick}>
		<SVG src={Arrow} />
	</div>
)

const HistoryTimeline = ({ data, cmsData }) => {
	const standarizedData = []
	if(cmsData){
		cmsData.items.map((item, index)=>{
			item.fields.id = index
			standarizedData.push(item.fields)
			return null
		})
	}
	
	const actualData = cmsData ? standarizedData : data
	const [currentSlide, setCurrentSlide] = useState(0)
	const years = actualData.map(item => item.subtitle)

	const sliderSettings = {
		customPaging: i => {
			return <StyledYear current={currentSlide}>{years[i]}</StyledYear>
		},
		infinite: true,
		arrows: true,
		dots: true,
		nextArrow: <SlickArrow />,
		prevArrow: <SlickArrow />,
		beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
	}


	return (
		<StyledSlider current={currentSlide} total={actualData.length + 1}>
			<StyledBackground src={HistoryBackground} />
			<StyledSliderWrapper>
				<Slider {...sliderSettings}>
					{actualData.map(year => {
						return (
							<TextHeader
								key={year.id}
								title={<h2>{year.title}</h2>}
								subtitle={year.subtitle}
								text={cmsData ? year.text : year.text.text}
								theme={{
									size: 'big',
									align: 'center',
								}}
							/>
						)
					})}
				</Slider>
			</StyledSliderWrapper>
		</StyledSlider>
	)
}

export default HistoryTimeline
